import Vue from 'vue'
import * as Cookies from 'js-cookie'
import Router from 'vue-router'
Vue.use(Router)

import routes from './routes'

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    let token = Cookies.get("token");
    let user = JSON.parse(localStorage.getItem('user'));
    let userType = user && user.user_type;
    let redirectArr = [null, 'Newhome', 'dashboard', 'AdminDashboard']
    const requireUser = to.matched.some(record => record.meta.requiresUser)
    const requireTrainer = to.matched.some(record => record.meta.requiresTrainer)
    const requireAdmin = to.matched.some(record => record.meta.requiresAdmin)
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (!token && (requiresAuth || requireUser || requireTrainer || requireAdmin)) {
        next({ name: 'Login' })
    } else if (token && (requireUser || requireTrainer || requireAdmin)) {
        if (requireUser && userType !==1) {
          next({name: redirectArr[userType]});
        } else if (requireTrainer && userType !==2) {
          next({name: redirectArr[userType]});
        } else if (requireAdmin && userType !==3) {
          next({name: redirectArr[userType]});
        }
    } else if (token && (to.path === '/login' || to.path === '/sign-up' || to.path === "/")) {
      next({name: redirectArr[userType]});
    }

    next()
})

export default router